import createStore from "react-auth-kit/createStore";
import { refresh } from "./Refresh";

const getCookieDomain = () => {
  const hostname = window.location.hostname;
  return hostname;
};

export const AuthStore = createStore({
  authName: "_auth",
  authType: "cookie",
  cookieDomain: getCookieDomain(),
  cookieSecure: window.location.protocol === "https:",
  cookieSameSite: "Lax",
  refresh: refresh,
});
